export const reviews = [
  {
    id: "1",
    name: "漫画迷小王",
    role: "资深读者",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20man%20portrait%20with%20glasses%2C%20friendly%20expression%2C%20simple%20warm%20background%2C%20anime%20style%20character%20design&width=120&height=120&seq=avatar-01&orientation=squarish",
    comment: "韩漫之家真的是我用过最好的韩漫平台！更新速度超快，基本上韩国那边刚更新这边就有了。而且阅读体验特别好，下拉式浏览非常流畅，推荐给所有喜欢韩漫的朋友！",
    rating: 5,
    date: "2026-06-28",
  },
  {
    id: "2",
    name: "樱花雨",
    role: "VIP会员",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20woman%20portrait%20with%20long%20hair%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20anime%20style%20character%20design&width=120&height=120&seq=avatar-02&orientation=squarish",
    comment: "从学生时代就开始看韩漫，换了好几个平台，最后留在了韩漫之家。分类很全，冷门作品也能找到。客服响应也很快，有一次链接打不开，反馈后半小时就修复了，真的很用心。",
    rating: 5,
    date: "2026-07-01",
  },
  {
    id: "3",
    name: "暗夜骑士",
    role: "认证读者",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cool%20man%20portrait%20with%20dark%20hair%2C%20confident%20expression%2C%20simple%20warm%20background%2C%20anime%20style%20character%20design&width=120&height=120&seq=avatar-03&orientation=squarish",
    comment: "作为热血漫爱好者，这里简直是天堂。《我独自升级》全系列都有，画质清晰无广告弹窗，这是我最看重的一点。每周准时蹲更新，已经成为生活的一部分了！",
    rating: 5,
    date: "2026-06-25",
  },
  {
    id: "4",
    name: "月光下的猫",
    role: "活跃用户",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cute%20girl%20portrait%20with%20twin%20tails%2C%20cheerful%20expression%2C%20simple%20warm%20background%2C%20anime%20style%20character%20design&width=120&height=120&seq=avatar-04&orientation=squarish",
    comment: "界面简洁清爽，没有乱七八糟的广告。最喜欢它的收藏功能，可以标记阅读进度，追更特别方便。而且分类做得很好，总能发现好看的新作品。强烈推荐！",
    rating: 4,
    date: "2026-07-03",
  },
  {
    id: "5",
    name: "北方的狼",
    role: "新用户",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20casual%20man%20portrait%20with%20beanie%20hat%2C%20relaxed%20expression%2C%20simple%20warm%20background%2C%20anime%20style%20character%20design&width=120&height=120&seq=avatar-05&orientation=squarish",
    comment: "朋友推荐的，用了一周感觉不错。漫画资源确实很全，有些在其他地方找不到的冷门作品这里都有。页面加载速度也很快，不会卡顿。希望能一直保持这个品质。",
    rating: 4,
    date: "2026-07-05",
  },
];

export const faqs = [
  {
    question: "韩漫之家是完全免费的吗？",
    answer: "是的，韩漫之家目前所有漫画内容均完全免费提供，无需付费即可畅享海量韩漫资源。我们通过广告收入维持运营，致力于为广大韩漫爱好者提供优质的阅读体验。",
  },
  {
    question: "漫画的更新频率是怎样的？",
    answer: "不同漫画的更新频率不同，大部分热门作品保持每周更新2-3次。每部漫画的详情页都会标注具体的更新日期，您可以关注喜欢的作品以获取最新更新通知。",
  },
  {
    question: "为什么有些漫画章节打不开？",
    answer: "如果遇到章节无法打开的情况，可能是由于网络波动或服务器临时维护。建议您刷新页面或稍后再试。如果问题持续存在，可以通过联系我们页面反馈，我们会在第一时间处理。",
  },
  {
    question: "可以在手机上阅读吗？",
    answer: "当然可以！韩漫之家全面适配移动端，支持手机和平板设备。您可以直接在浏览器中访问我们的网站，享受流畅的下拉式阅读体验，无需下载任何App。",
  },
  {
    question: "如何找到我想看的漫画类型？",
    answer: "您可以通过首页的分类导航浏览各个类型的漫画，也可以使用搜索功能直接查找作品名称。另外，排行榜和热门推荐也是发现好作品的好方式。",
  },
];

export const aboutInfo = {
  brand: {
    name: "韩漫之家",
    slogan: "免费韩漫 · 精彩阅读",
    founded: "2020年",
    mission: "让每一位韩漫爱好者都能轻松获取优质韩漫资源，享受无缝的阅读体验。",
    story: "韩漫之家由一群热爱韩国漫画的年轻人于2020年创立。创始人发现国内韩漫读者面临着资源分散、翻译质量良莠不齐、阅读体验差等问题，于是决心打造一个专业、免费的韩漫阅读平台。从最初的几十部漫画起步，经过团队的不懈努力，如今韩漫之家已发展成为国内领先的韩漫阅读平台之一，拥有上万部漫画资源，每日服务数百万读者。我们始终秉持\"读者至上\"的理念，不断优化阅读体验，丰富内容资源，希望能成为每一位韩漫爱好者最信赖的伙伴。",
  },
  stats: [
    { label: "漫画总量", value: "10,000+" },
    { label: "日活跃用户", value: "200万+" },
    { label: "累计阅读量", value: "50亿+" },
    { label: "用户好评率", value: "98.5%" },
  ],
};